import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
export function Screen({ workspace = false, children, className, style }) {
    return (_jsx("div", { className: cx('screen', workspace && 'screen--workspace', className), style: style, children: children }));
}
export function ScreenHeader({ eyebrow, title, lead, actions, className, style }) {
    return (_jsxs("header", { className: cx('screen-head', className), style: style, children: [_jsxs("div", { className: "htext", children: [eyebrow !== undefined && _jsx("div", { className: "eyebrow", children: eyebrow }), _jsx("h1", { children: title }), lead !== undefined && _jsx("p", { className: "lead", children: lead })] }), actions !== undefined && _jsx("div", { className: "actions", children: actions })] }));
}
export function FilterBar({ label, children, className, style }) {
    return (_jsxs("div", { className: cx('toolbar', className), style: style, role: "group", children: [label !== undefined && _jsx("span", { className: "tb-label", children: label }), children] }));
}
export function Chip({ active = false, onClick, children, className, title }) {
    return (_jsx("button", { type: "button", className: cx('chip', className), "aria-pressed": active, onClick: onClick, title: title, children: children }));
}
export function MetaGrid({ labelWidth, children, className, style }) {
    const s = labelWidth !== undefined
        ? { '--meta-label': typeof labelWidth === 'number' ? `${labelWidth}px` : labelWidth, ...style }
        : style;
    return (_jsx("dl", { className: cx('meta-grid', className), style: s, children: children }));
}
export function MetaItem({ label, children }) {
    return (_jsxs(_Fragment, { children: [_jsx("dt", { children: label }), _jsx("dd", { children: children })] }));
}
export function ListItem({ active = false, onSelect, children, className, style }) {
    return (_jsx("div", { role: "button", tabIndex: 0, "aria-current": active || undefined, className: cx('list-item', active && 'active', className), style: style, onClick: onSelect, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect?.();
            }
        }, children: children }));
}
export function Workspace({ rail, children, className, style }) {
    const s = rail !== undefined
        ? { '--rail': typeof rail === 'number' ? `${rail}px` : rail, ...style }
        : style;
    return (_jsx("div", { className: cx('workspace', className), style: s, children: children }));
}
/** A scrolling pane within a Workspace. Order decides rail vs main (grid columns size them). */
export function WorkspacePane({ children, flush = false, className, style, }) {
    return (_jsx("div", { className: cx('pane', flush && 'flush-pane', className), style: style, children: children }));
}
export function SummaryTiles({ min, children, className, style }) {
    const s = min !== undefined
        ? { '--tile': typeof min === 'number' ? `${min}px` : min, ...style }
        : style;
    return (_jsx("div", { className: cx('summary-tiles', className), style: s, children: children }));
}
export function StatTile({ label, value, sub, valueStyle, className, }) {
    return (_jsxs("div", { className: cx('stat-tile', className), children: [_jsx("div", { className: "st-k", children: label }), _jsx("div", { className: "st-v", style: valueStyle, children: value }), sub !== undefined && _jsx("div", { className: "st-sub", children: sub })] }));
}
//# sourceMappingURL=Scaffold.js.map